interface LayoutProps {
  children: React.ReactNode;
}

export function LayoutPadding({ children }: LayoutProps): JSX.Element {
  return <div className="px-8 lg:px-32 w-full h-full">{children}</div>;
}
